import React from "react";
import PropTypes from "prop-types";
import Materialicon from "../../helpers/Materialicon";

const ProjectInfoCart= (props) => (		  
	<div className="project-card project-info">
		<h3 className="card-title">{props.text}</h3>
		<div className="media">
			<div className="media-left meida media-middle">
				<span><Materialicon icon={props.icon}/></span>
			</div>
			<div className="media-body media-text-right">
				<h2 className="value">{props.value}</h2>
				<p>Total {props.text}</p>
			</div>
		</div>
	</div>
);

ProjectInfoCart.defaultProps = {
	value: null,
};

ProjectInfoCart.propTypes = {
	icon: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	value: PropTypes.number
};
export default ProjectInfoCart;



// WEBPACK FOOTER //
// ./src/components/pages/projects/ProjectInfoCart.js